import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  ACCOUNTING_BILLING_LIST_REQUEST,
  ACCOUNTING_BILLING_LIST_SUCCESS,
  ACCOUNTING_BILLING_LIST_FAILURE,
  ACCOUNTING_BILLING_GET_REQUEST,
  ACCOUNTING_BILLING_GET_SUCCESS,
  ACCOUNTING_BILLING_GET_FAILURE,
  ACCOUNTING_BILLING_GET_RESET,
  ACCOUNTING_BILLING_EDIT_REQUEST,
  ACCOUNTING_BILLING_EDIT_SUCCESS,
  ACCOUNTING_BILLING_EDIT_FAILURE,
  ACCOUNTING_BILLING_EDIT_RESET,
  ACCOUNTING_BILLING_EXPORT_REQUEST,
  ACCOUNTING_BILLING_EXPORT_SUCCESS,
  ACCOUNTING_BILLING_EXPORT_FAILURE,
  ACCOUNTING_BILLING_EXPORT_RESET,
  ACCOUNTING_PAYING_LIST_REQUEST,
  ACCOUNTING_PAYING_LIST_SUCCESS,
  ACCOUNTING_PAYING_LIST_FAILURE,
  ACCOUNTING_PAYING_GET_REQUEST,
  ACCOUNTING_PAYING_GET_SUCCESS,
  ACCOUNTING_PAYING_GET_FAILURE,
  ACCOUNTING_PAYING_GET_RESET,
  ACCOUNTING_PAYING_EDIT_REQUEST,
  ACCOUNTING_PAYING_EDIT_SUCCESS,
  ACCOUNTING_PAYING_EDIT_FAILURE,
  ACCOUNTING_PAYING_EDIT_RESET,
  ACCOUNTING_PAYING_EXPORT_REQUEST,
  ACCOUNTING_PAYING_EXPORT_SUCCESS,
  ACCOUNTING_PAYING_EXPORT_FAILURE,
  ACCOUNTING_PAYING_EXPORT_RESET,
  OPEN_RESPONSE_MODAL_ACCOUNTING,
  SET_KEYWORD_SEARCH_ACCOUNTING,
  SET_AP_FILTER,
  SET_AR_FILTER,
} from './types'

export function getBillings(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/accountant-billings`,
      method: 'GET',
      types: [
        ACCOUNTING_BILLING_LIST_REQUEST,
        ACCOUNTING_BILLING_LIST_SUCCESS,
        ACCOUNTING_BILLING_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getBillingtById(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/accountant-billings/${id}`,
      method: 'GET',
      types: [
        ACCOUNTING_BILLING_GET_REQUEST,
        ACCOUNTING_BILLING_GET_SUCCESS,
        ACCOUNTING_BILLING_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editBilling(id, billing_id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/accountant-billings/${id}/${billing_id}`,
      method: 'PUT',
      types: [
        ACCOUNTING_BILLING_EDIT_REQUEST,
        ACCOUNTING_BILLING_EDIT_SUCCESS,
        ACCOUNTING_BILLING_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function exportBillings(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/accountant-billings/export`,
      method: 'GET',
      types: [
        ACCOUNTING_BILLING_EXPORT_REQUEST,
        ACCOUNTING_BILLING_EXPORT_SUCCESS,
        ACCOUNTING_BILLING_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getPayings(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/accountant-payings`,
      method: 'GET',
      types: [
        ACCOUNTING_PAYING_LIST_REQUEST,
        ACCOUNTING_PAYING_LIST_SUCCESS,
        ACCOUNTING_PAYING_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getPayingById(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/accountant-payings/${id}`,
      method: 'GET',
      types: [
        ACCOUNTING_PAYING_GET_REQUEST,
        ACCOUNTING_PAYING_GET_SUCCESS,
        ACCOUNTING_PAYING_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editPaying(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/accountant-payings/${id}`,
      method: 'PUT',
      types: [
        ACCOUNTING_PAYING_EDIT_REQUEST,
        ACCOUNTING_PAYING_EDIT_SUCCESS,
        ACCOUNTING_PAYING_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function exportPayings(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/accountant-payings/export`,
      method: 'GET',
      types: [
        ACCOUNTING_PAYING_EXPORT_REQUEST,
        ACCOUNTING_PAYING_EXPORT_SUCCESS,
        ACCOUNTING_PAYING_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function resetGetBilling() {
  return {
    type: ACCOUNTING_BILLING_GET_RESET,
  }
}

export function resetUpdatedBilling() {
  return {
    type: ACCOUNTING_BILLING_EDIT_RESET,
  }
}

export function resetGetPaying() {
  return {
    type: ACCOUNTING_PAYING_GET_RESET,
  }
}

export function resetUpdatedPaying() {
  return {
    type: ACCOUNTING_PAYING_EDIT_RESET,
  }
}

export function resetExportBillings() {
  return {
    type: ACCOUNTING_BILLING_EXPORT_RESET,
  }
}

export function resetExportPayings() {
  return {
    type: ACCOUNTING_PAYING_EXPORT_RESET,
  }
}

export function openResponseModal(payload) {
  return {
    type: OPEN_RESPONSE_MODAL_ACCOUNTING,
    payload,
  }
}

export function setKeywordSearch(payload) {
  return {
    type: SET_KEYWORD_SEARCH_ACCOUNTING,
    payload,
  }
}

export function setAPFilter(payload) {
  return {
    type: SET_AP_FILTER,
    payload,
  }
}

export function setARFilter(payload) {
  return {
    type: SET_AR_FILTER,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/actions/accounting-dashboard/accounting.js